import type { OMSConfig, StrategyEvaluator, SignalResult, StrategyContext } from '../types';
import { extractSpotPrice } from '../../../lib/snapshot-search';
import { ensureFlatOpts } from '../../analysis/trend-evaluator';
import { getConnectingDotsRows, getSortKey } from './shared';

export const evaluateMinMaxItmTop5Sell: StrategyEvaluator = (marketData: any, currentUnixTime: number, config: OMSConfig, context: StrategyContext): SignalResult[] | null => {
    if (!marketData) return null;

    const { symbol, expiry, activeRange, gap, settingsMode } = context;
    const spot = extractSpotPrice(marketData) || 0;
    if (spot <= 0) return null;
    
    const atmStrike = Math.round(spot / gap) * gap;

    const { itmRows } = getConnectingDotsRows(marketData, symbol, expiry, atmStrike, activeRange, gap);
    itmRows.sort((a: any, b: any) => getSortKey(b, settingsMode) - getSortKey(a, settingsMode));

    const top5Itm = itmRows.slice(0, 5);
    if (top5Itm.length < 2) return null; // Need at least some strikes

    const strikes = top5Itm.map((r: any) => r.strike);
    const minStrike = Math.min(...strikes);
    const maxStrike = Math.max(...strikes);

    const liveRawOptsArr = context.chain || marketData.options || marketData.optionChain || [];
    const liveFlatOpts = ensureFlatOpts(liveRawOptsArr);

    const minRow = liveFlatOpts.find((r: any) => r.strike === minStrike && r.type === 'PE');
    const maxRow = liveFlatOpts.find((r: any) => r.strike === maxStrike && r.type === 'CE');

    const signals: SignalResult[] = [];

    if (minRow) {
        const entryPrice = minRow.ltp || minRow.close || minRow.price || 0;
        if (entryPrice > 0) {
            signals.push({
                trade_type: 'BULL', // Selling PE is Bullish
                strike: minStrike,
                option_type: 'PE',
                entry_price: entryPrice,
                remarks: `Sell MIN ITM Top5 (${minStrike})`,
                exact_match: true
            });
        }
    }

    if (maxRow) {
        const entryPrice = maxRow.ltp || maxRow.close || maxRow.price || 0;
        if (entryPrice > 0) {
            signals.push({
                trade_type: 'BEAR', // Selling CE is Bearish
                strike: maxStrike,
                option_type: 'CE',
                entry_price: entryPrice,
                remarks: `Sell MAX ITM Top5 (${maxStrike})`,
                exact_match: true
            });
        }
    }

    if (signals.length === 2) {
        return signals; // Ensure both legs are present
    }

    return null;
};
